import axios from 'axios';
export const createValidatedCertificateAccessToken = async (imageStoreApiRoot, encryptionKey, certificateId) => axios
    .post(`${imageStoreApiRoot}/${certificateId}/authorize`, {
    encryptionKey: encryptionKey,
})
    .then((output) => output.data);
const getValidatedCertificateFor = async (imageStoreApiRoot, certificateId, accessToken, output) => axios
    .post(`${imageStoreApiRoot}/${certificateId}`, {
    accessToken: accessToken,
}, {
    headers: {
        accept: output,
    },
})
    .then((output) => output.data);
export const getValidatedCertificate = async (imageStoreApiRoot, certificateId, accessToken) => getValidatedCertificateFor(imageStoreApiRoot, certificateId, accessToken, CertificateFormatOutput.IMAGE);
export const getValidatedEdciCertificate = async (imageStoreApiRoot, certificateId, accessToken) => getValidatedCertificateFor(imageStoreApiRoot, certificateId, accessToken, CertificateFormatOutput.EML_JSON);
export var CertificateFormatOutput;
(function (CertificateFormatOutput) {
    CertificateFormatOutput["IMAGE"] = "text/x-data-url";
    CertificateFormatOutput["EML_JSON"] = "text/x-data-url+eml";
})(CertificateFormatOutput || (CertificateFormatOutput = {}));
export const supportsEdci = async (imageStoreApiRoot, certificateId) => {
    const url = `${imageStoreApiRoot}/${certificateId}`;
    return axios
        .head(url, {
        headers: {
            accept: 'application/json+eml',
        },
    })
        .then((output) => {
        return output.status === 201;
    })
        .catch((e) => (e.response?.status === 404 ? Promise.resolve(false) : e));
};
export class ImageStoreUrlBuilder {
    imageStoreApiRoot;
    constructor(imageStoreApiRoot) {
        this.imageStoreApiRoot = imageStoreApiRoot;
    }
    deferredEncryptedImageUrl(certificateId) {
        return `${this.imageStoreApiRoot}/certificate/${certificateId}/encryptedImageUrl`;
    }
}
export const getCertificatePdf = async (imageStoreApiRoot, certificateId, languageTag, accessToken) => axios
    .post(`${imageStoreApiRoot}/${certificateId}/pdf`, {
    accessToken: accessToken,
    languageTag: languageTag,
}, {
    headers: {
        accept: 'text/x-data-url+pdf',
    },
})
    .then((output) => output.data);
export const getPreSignedUrlForDecryptedCertificate = async (imageStoreApiRoot, certificateId, accessToken) => preSignedUrlFor(`${imageStoreApiRoot}/${certificateId}`, accessToken);
export const getPreSignedUrlForCertificatePdf = async (imageStoreApiRoot, certificateId, accessToken, languageTag) => preSignedUrlFor(`${imageStoreApiRoot}/${certificateId}/pdf`, accessToken, languageTag);
const preSignedUrlFor = async (url, accessToken, languageTag = 'en') => axios
    .get(url, {
    headers: { Authorization: accessToken.value() },
    params: {
        lang: languageTag,
    },
})
    .then((response) => response.data)
    .then((json) => json.preSignedUrl);
export class SdkImageStore {
    imageStoreApiRoot;
    tokenStore;
    constructor(imageStoreApiRoot, tokenStore) {
        this.imageStoreApiRoot = imageStoreApiRoot;
        this.tokenStore = tokenStore;
    }
    async getCertificateAsset(certificateId, assetId) {
        const token = await this.tokenStore.retrieveClientCredentials();
        const response = await axios.get(`${this.imageStoreApiRoot}/assets/cert/${certificateId}/${assetId}`, {
            headers: {
                Authorization: token.value(),
            },
        });
        const presignedUrl = response.data.location;
        return axios
            .get(presignedUrl, { responseType: 'arraybuffer' })
            .then((response) => Buffer.from(response.data, 'binary'));
    }
    async confirmCertificateAsset(organizationId, certificateId, assetId) {
        const token = await this.tokenStore.retrieveClientCredentials();
        await axios.post(`${this.imageStoreApiRoot}/assets/cert/${certificateId}/${assetId}`, {
            organizationId,
        }, {
            headers: {
                Authorization: token.value(),
            },
        });
        return;
    }
    async getBulkAsset(bulkId, assetId) {
        const token = await this.tokenStore.retrieveClientCredentials();
        const response = await axios.get(`${this.imageStoreApiRoot}/assets/bulk/${bulkId}/${assetId}`, {
            headers: {
                Authorization: token.value(),
            },
        });
        const presignedUrl = response.data.location;
        return axios.get(presignedUrl, { responseType: 'arraybuffer' }).then((response) => {
            return {
                contentType: response.headers['content-type'],
                data: Buffer.from(response.data, 'binary'),
            };
        });
    }
    async confirmBulkAsset(organizationId, bulkId, assetId) {
        const token = await this.tokenStore.retrieveClientCredentials();
        await axios.post(`${this.imageStoreApiRoot}/assets/bulk/${bulkId}/${assetId}`, {
            organizationId,
        }, {
            headers: {
                Authorization: token.value(),
            },
        });
        return;
    }
}
export const getOrganizationAssetUploadUrl = async (imageStoreApiRoot, wallet, accessToken) => axios
    .post(`${imageStoreApiRoot}/assets/org/${wallet}`, {}, {
    headers: { Authorization: accessToken.value() },
})
    .then((response) => {
    return {
        uploadUrl: response.data.location,
        assetId: response.data.id,
    };
});
export const getValidatedCertificateAsset = async (imageStoreApiRoot, input, token) => axios
    .get(`${imageStoreApiRoot}/assets/cert/${input.certificateId}/${input.assetId}`, {
    headers: {
        Authorization: token.value(),
    },
})
    .then(async (response) => {
    return axios.get(response.data.location, { responseType: 'arraybuffer' });
});
//# sourceMappingURL=index.js.map